module.exports = "https://assets.niwcorp.com/_next/static/images/img-oval-btm-left-183fdc2be701f192c4519be9c72d88fc.svg";